export default class AppRoutes {
  static landing = "/landing";
  static register = "/register";
  static home = "/home";
  static dashboard = "/dashboard";
  static dashboardListing = "/dashboard-listing";
  static history = "/history";
  static historyDetail = "/history-detail";
  static user = "/user";
  static search = "/search";
  static detail = "/details";
  static facility = "/facilities";
  static partner = "/partners";
  static airDineFacility = "/airdine-facilities";
  static benefitDetails = "/benefit-details";
  static facilityDetails = "/facility-details";
  static railwaySuccess = "/railway-success";
  static termAndCondition = "/terms-and-conditions";
  static contactUs = "/contact-us";
  static privacyAndPolicy = "/privacy-policy";
  static login = "/login";
  static signUp = "/signup";
  static about = "/about-us";
  static services = "/services";
  static help = "/help";
  static addMembership = "/add-membership";
  static diningFacilityDetails = "/airdine-facility-details";
  static account = "/profile/account";
  static profileInfo = "/profile/profile-info";
  static settings = "/profile/settings";
  static savings = "/profile/savings";
  static bookingDetails = "/booking-details";
  static delayedBookingDetails = "/benefit-delay-details";
  static faq = "/faq";
  static feedback = "/profile/support/feedback-n-query";
  static query = "/profile/support/query";
  static support = "/profile/support";
  static features = "/features";
  static refundPolicy = "/refund-policy";
  static linkMembership = "/link-membership";
  static manageDevices = "/profile/settings/manage-devices";
  static listing = "/listing";
  static listingDetail = "/listing-detail";
  static airportTransfer = "/airport-transfer";
  static paddleDetails = "/paddle-detail";
  static valetParking = "/valet-parking";
  static forgotPassword = "/forgotpassword";
  static bookmarks = "/bookmarks";
  static iListing = "/offer-details";
  static offers = "/offer";
  static travelDetails = "/travel-details";
  static golfdetails = "/golf-detail";
  static loginLinkMembership = "/login-link-membership";
}
